import { render } from "./Comment.vue?vue&type=template&id=69d88e3b&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"

import "./Comment.vue?vue&type=style&index=0&id=69d88e3b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69d88e3b"

export default script